import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import TaskForm from './TaskForm';
import { isAdminRole, isEmptyObj, actionTypeOptions, isSupportUser, isMessageAdminRole } from '../../../utils/mics';
import { MultiSelect } from 'primereact/multiselect';

const TaskFilterBar = (props) => {
    const task = useSelector((state) => state.task.task);
    const priorityOptions = useSelector((state) => state.common.priorityList);
    // const taskTypeOptions = useSelector((state) => state.common.taskTypeList);
    const repeatOptions = useSelector((state) => state.common.repeatList);
    const progressOptions = useSelector((state) => state.common.progressList);
    const storeOtions = useSelector((state) => state.common.storeList);
    const userOptions = useSelector((state) => state.common.userList);
    const siteGroupOptions = useSelector((state) => state.common.siteGroupList);

    const { userInfo } = props;
    const { userRole } = userInfo;

    const [visible, setVisible] = useState(false);
    const [isEmptyParams, setIsEmptyParams] = useState(true);
    const { pageParams } = props;

    useEffect(() => {
        if (task.id) {
            setVisible(false);
        }
    }, [task]);

    const formik = useFormik({
        initialValues: {
            taskType: [],
            taskDateTime: '',
            dueDateTime: '',
            priority: '',
            repeatType: '',
            assignedTo: '',
            assignedBy: '',
            status: '',
            siteId: '',
            assignType: ''
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const assignedTo = values?.assignedTo || ''
            const data = {
                ...values,
                taskDateTime: values.taskDateTime
                    ? moment(values.taskDateTime).format('DD-MM-YYYY')
                    : '',
                dueDateTime: values.dueDateTime
                    ? moment(values.dueDateTime).format('DD-MM-YYYY')
                    : '',
                taskType: values?.taskType?.join(',') || '',
                assignedTo: Array.isArray(assignedTo) ? assignedTo?.join(',') || '' : values?.assignedTo,
            };
            if(data.assignType === 'user'){
                data.siteId = '';
            } 
            
            const params = data;
            Object.keys(params).forEach((key) => {
                if (params[key] === '') {
                    delete params[key];
                }
            });
            
            const isEmptyObjParams = isEmptyObj(params);
            setIsEmptyParams(isEmptyObjParams);
            
            if(isEmptyObjParams) {
                //For handling of reset filter to get back the previous filter params
                const defaultParams = {...pageParams};
                delete defaultParams['activeGroup'];
                props.handleFilter(defaultParams);
            }
            else {
                props.handleFilter(params);
            }
            
        },
    });

    const handleReset = () => {
        formik.resetForm();
        setIsEmptyParams(true);
    };

    const handleAudienceChange = (e) => {
        formik.values.assignedTo = '';
        formik.setFieldValue('assignType', e.value)
    };

    useEffect(() => {
        // Reset form whenever the component is mounted (page load)
        formik.resetForm();
    }, [pageParams]); // Empty dependency array ensures this runs only once on mount

    const isEmpty = (obj) => {
        return isEmptyObj(obj);
    };

    return (
        <>
            <Dialog
                header="Create a New Message"
                visible={visible}
                style={{ width: '75vw' }}
                onHide={() => setVisible(false)}
            >
                <TaskForm />
            </Dialog>

            <div className="flex align-items-end mb-3 mt-2">
                <form onSubmit={formik.handleSubmit} className='mr-auto'>
                    <div className="flex flex-wrap align-items-end gap-10">
                        <div className="form-group">
                            <label>Priority</label>
                            <Dropdown
                                className="w-full"
                                id="priority"
                                value={formik.values.priority}
                                options={priorityOptions}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Start Date</label>
                            <Calendar
                                id="taskDateTime"
                                className='filter-date'
                                dateFormat="dd/mm/yy"
                                value={formik.values.taskDateTime}
                                onChange={formik.handleChange}
                                placeholder="(Default)"
                            />
                        </div>
                        <div className="form-group">
                            <label>End Date</label>
                            <Calendar
                                id="dueDateTime"
                                className='filter-date'
                                dateFormat="dd/mm/yy"
                                value={formik.values.dueDateTime}
                                onChange={formik.handleChange}
                                placeholder="(Default)"
                            />
                        </div>
                        <div className="form-group">
                            <label>Audience</label>
                            <Dropdown
                                className="w-full"
                                id="assignType"
                                value={formik.values.assignType}
                                options={actionTypeOptions}
                                onChange={(e) => handleAudienceChange(e)}
                                optionLabel="name"
                                optionValue='code'
                            />
                        </div>
                        { formik.values.assignType === 'user' &&
                            <div className="form-group">
                                <label>Assigned To</label>
                                <Dropdown
                                    className="w-full"
                                    id="assignedTo"
                                    value={formik.values.assignedTo}
                                    options={userOptions}
                                    onChange={(e) => formik.setFieldValue('assignedTo', e.value)} 
                                />
                            </div>
                        }
                        { (formik.values.assignType === 'site' ) &&
                            <div className="form-group">
                                <label>Site</label>
                                <Dropdown
                                    className="w-full"
                                    id="siteId"
                                    value={formik.values.assignedTo}
                                    options={storeOtions}
                                    onChange={(e) => formik.setFieldValue('assignedTo', e.value)} 
                                />
                            </div>
                        }
                        { (formik.values.assignType === 'site-group' ) &&
                            <div className="form-group">
                                <label>Site Group</label>
                                {/* <Dropdown
                                    className="w-full"
                                    id="taskType"
                                    value={formik.values.taskType}
                                    options={siteGroupOptions}
                                    onChange={formik.handleChange}
                                /> */}
                                <MultiSelect 
                                    id="taskType"
                                    value={formik.values.assignedTo} 
                                    onChange={(e) => formik.setFieldValue('assignedTo', e.value)} 
                                    options={siteGroupOptions}
                                    optionLabel="label" 
                                    filter 
                                    placeholder="Site Group" 
                                    className="w-full"
                                    maxSelectedLabels={3}  />
                            </div>
                        }
                        <div className="form-group">
                            <label>Repeat</label>
                            <Dropdown
                                className="w-full"
                                id="repeatType"
                                value={formik.values.repeatType}
                                options={repeatOptions}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Status</label>
                            <Dropdown
                                className="w-full"
                                id="status"
                                value={formik.values.status}
                                options={progressOptions}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Assigned By</label>
                            <Dropdown
                                className="w-full"
                                id="assignedBy"
                                value={formik.values.assignedBy}
                                options={userOptions}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <Button type="submit" icon="pi pi-search" severity="basic" style={{ height : '40px' }}/>
                        {!isEmptyParams ? (
                        <Button
                            onClick={handleReset}
                            icon="pi pi-times"
                            severity="secondary"
                            aria-label="Cancel"
                            style={{ height : '40px'}}
                        />
                        ) : ''}
                    </div>
                </form>
                {( isAdminRole(userRole) || isSupportUser(userRole) || isMessageAdminRole(userRole) ) && (
                    <Button
                        label="Create a New Message"
                        severity="basic"
                        style={{ width: '200px', height : '40px', minWidth : '200px'  }}
                        onClick={() => setVisible(true)}
                    />
                )}
            </div>
        </>
    );
};

export default TaskFilterBar;
